// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"menuText": "#d4dce6",
	"menuActiveText": "#59d3c9",
	"subMenuActiveText": "#f4f4f5",
	"menuBg": "#1a5458",
	"menuHover": "#329aa1",
	"subMenuBg": "#1a5458",
	"subMenuHover": "#329aa1",
	"sideBarWidth": "210px"
};
module.exports = exports;
